import React from "react";
import { Calendar } from "react-date-range";
import LocationSelect from "../maps/LocationSelect";
import useOutsideClick from "../../hooks/useOutsideClick";
import { enUS } from "date-fns/locale";

type VehicleSearchProps = {
  setShowPickupDate: React.Dispatch<React.SetStateAction<boolean>>;
  setShowReturnDate: React.Dispatch<React.SetStateAction<boolean>>;
  showPickupDate: boolean;
  showReturnDate: boolean;
  pickupDate: string;
  returnDate: string;
  handlePickupDateSelect: (e: any) => void;
  handleReturnDateSelect: (e: any) => void;
  setPickupLocation: React.Dispatch<
    React.SetStateAction<{
      lat: number;
      lng: number;
      loc: string;
    } | null>
  >;
  handleVehicleSearchSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  setPickupTime: React.Dispatch<React.SetStateAction<string>>;
  setReturnTime: React.Dispatch<React.SetStateAction<string>>;
  prefillLocation: string;
  pickupTime: string;
  returnTime: string;
};
const VehicleSearch: React.FC<VehicleSearchProps> = ({
  setShowPickupDate,
  setShowReturnDate,
  showPickupDate,
  showReturnDate,
  pickupDate,
  returnDate,
  handlePickupDateSelect,
  handleReturnDateSelect,
  setPickupLocation,
  handleVehicleSearchSubmit,
  setPickupTime,
  setReturnTime,
  prefillLocation,
  pickupTime,
  returnTime,
}) => {
  const pickupDateRef = React.useRef(null);
  const returnDateRef = React.useRef(null);

  useOutsideClick(pickupDateRef, () => {
    if (showPickupDate) {
      setShowPickupDate(false);
    }
  });

  useOutsideClick(returnDateRef, () => {
    if (showReturnDate) {
      setShowReturnDate(false);
    }
  });

  const handleSelectLocation = (lat: number, lng: number, loc: string) => {
    // console.log("location select", lat, lng, loc);

    setPickupLocation({ lat, lng, loc });
  };

  // console.log(prefillLocation);
  return (
    <div className="w-full mx-auto lg:px-5 bg-white border rounded-lg flex flex-col pb-5 ">
      <div className="flex w-full">
        <h2 className="w-full text-center lg:text-left text-darkText py-4 font-Poppins text-[18px]  leading-tight text-edge-cap uppercase font-semibold">
          Make your trip
        </h2>
      </div>

      <form
        action=""
        onSubmit={handleVehicleSearchSubmit}
        className="w-[90%] lg:w-full  flex flex-col lg:flex-row  justify-center mx-auto  font-Poppins font-[11px] text-darkGreen gap-4 "
      >
        <div className="flex flex-col mx-auto w-full ">
          <label htmlFor="" className="md:text-center text-[13px] w-full">
            {" "}
            Pickup Location
          </label>
          {/* <input
            type="text"
            placeholder="20 Cooper Square, New York, NY 10003, USA"
            className="border rounded-md px-5 lg:px-2 bg-transparent border-gray-300 text-[13px]   text-greyText font-Poppins py-3"
          /> */}

          <LocationSelect
            inputId="search-input"
            mapId="search-map"
            handleSelectLocation={handleSelectLocation}
            showMap={false}
            prefillLocation={prefillLocation}
            extraStyles="border rounded-md px-5 lg:px-2 bg-transparent border-gray-300 text-[15px]   text-greyText font-Poppins py-3"
          />
        </div>
        <div
          className="relative flex flex-row  gap-4 mx-auto justify-between w-full"
          ref={pickupDateRef}
        >
          <div className="flex flex-col w-2/5 lg:w-1/2">
            <label htmlFor="" className="md:text-center text-[13px]">
              {" "}
              Pickup Date
            </label>
            <div
              className="border rounded-md px-3  bg-transparent border-gray-300 text-[13px] text-center  text-greyText font-Poppins py-3 cursor-pointer "
              onClick={() => {
                setShowPickupDate(!showPickupDate);
                setShowReturnDate(false);
              }}
            >
              {pickupDate}
            </div>
          </div>
          <div className="w-full absolute top-[50px] left-0 z-20">
            {showPickupDate && (
              <Calendar
                locale={enUS}
                date={new Date()}
                minDate={new Date()}
                onChange={handlePickupDateSelect}
              />
            )}
          </div>
          <div className="flex flex-col w-2/5 lg:w-1/2">
            <label htmlFor="" className="md:text-center text-[13px]">
              {" "}
              Pickup Time
            </label>
            <input
              type="time"
              placeholder="12:00"
              value={pickupTime}
              onChange={(e) => {
                setPickupTime(e.target.value);
              }}
              className="border  rounded-md px-1 bg-transparent border-gray-300 font-[8px] text-center text-greyText font-Poppins py-2 cursor-pointer"
            />
          </div>
        </div>
        <div
          className="relative flex flex-row  gap-4 mx-auto justify-between w-full"
          ref={returnDateRef}
        >
          <div className="flex flex-col w-2/5 lg:w-1/2">
            <label htmlFor="" className="md:text-center text-[13px]">
              Return Date
            </label>
            <div
              className="border date-input rounded-md px-3  bg-transparent border-gray-300 text-[13px] text-center  text-greyText font-Poppins py-3 cursor-pointer "
              onClick={() => {
                setShowReturnDate(!showReturnDate);
                setShowPickupDate(false);
              }}
            >
              {returnDate}
            </div>
          </div>
          <div className="w-full absolute top-[50px] left-0 z-20 ">
            {showReturnDate && (
              <Calendar
                locale={enUS}
                date={new Date()}
                minDate={new Date()}
                onChange={handleReturnDateSelect}
              />
            )}
          </div>
          <div className="flex flex-col w-2/5 lg:w-1/2">
            <label htmlFor="" className="md:text-center text-[13px]">
              {" "}
              Return Time
            </label>
            <input
              type="time"
              placeholder="12:00"
              value={returnTime}
              onChange={(e) => {
                setReturnTime(e.target.value);
              }}
              className="border rounded-md px-1 bg-transparent border-gray-300 font-[8px] text-center  text-greyText  font-Poppins py-2 cursor-pointer"
            />
          </div>
        </div>
        <button
          type="submit"
          className=" px-5 py-3  rounded-md bg-lightGreen font-Poppins font-medium text-center text-darkText"
        >
          Search
        </button>
      </form>
    </div>
  );
};

export default VehicleSearch;
